import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { BillChargeService } from "./bill-charge.service";
import { BillCharge } from "./ibill-charge";
import { LoginService } from "src/app/login.service";
import { ROLE_GROUPS } from "src/app/common/authorization/roles";

@Injectable({
    providedIn: 'root'
})
export class BillChargeResolver implements Resolve<any> {
    constructor(
        private _billChargeService: BillChargeService,
        private _loginService: LoginService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BaseRespone<{ pagination: PaginationResult, billCharges: BillCharge[] }> | null> {
        if (!this._loginService.hasAnyRole(ROLE_GROUPS.AllTenant)) {
            return of(null);
        }
        const data = {
            pageNumber: 0,
            pageSize: 100,
        };
        return this._billChargeService.getBillCharge(data);
    }
}